// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1tS9K","header":"ReportDetails_header__3WXj0","title":"ReportDetails_title__1dXHL","left":"ReportDetails_left__2g9ir"};